import '../assets/NcChip-CF4Q149V.css';
import { c as mdiClose } from "../chunks/mdi-C1L0jZ1V.mjs";
import { useSlots, computed } from "vue";
import { r as register, n as t17, a as t } from "../chunks/_l10n-DIOHNc85.mjs";
import { N as NcActions } from "../chunks/NcActions-CzpbMJoY.mjs";
import { N as NcActionButton } from "../chunks/NcActionButton-CpGK6gSX.mjs";
import { N as NcIconSvgWrapper } from "../chunks/NcIconSvgWrapper-Cb-cPj1R.mjs";
import { n as normalizeComponent } from "../chunks/_plugin-vue2_normalizer-DU4iP6Vu.mjs";
register(t17);
const _sfc_main = {
  __name: "NcChip",
  props: {
    /**
     * aria label to set on the close button
     * @default 'Close'
     */
    ariaLabelClose: {
      type: String,
      default: t("Close")
    },
    /**
     * Container for the actions
     */
    actionsContainer: {
      type: String,
      default: "body"
    },
    /**
     * Main text of the chip.
     */
    text: {
      type: String,
      default: ""
    },
    /**
     * Set the chips design variant-
     *
     * This sets the background style of the chip, similar to NcButton's `variant`.
     * @deprecated will be removed with v9 - use `variant` instead.
     */
    type: {
      type: String,
      default: "secondary",
      validator: (value) => ["primary", "secondary", "tertiary"].includes(value)
    },
    /**
     * SVG path of the icon to use, this takes precedence over `iconSVG`.
     * For example icon paths from `@mdi/js` can be used.
     */
    iconPath: {
      type: String,
      default: null
    },
    /**
     * Inline SVG to use as the icon
     */
    iconSvg: {
      type: String,
      default: null
    },
    /**
     * Set to true to prevent the close button to be shown
     */
    noClose: {
      type: Boolean,
      default: false
    },
    /**
     * Set the chips design variant-
     *
     * This sets the background style of the chip, similar to NcButton's `variant`.
     * @since 8.24.0
     */
    variant: {
      type: String,
      default: "secondary",
      validator: (value) => ["primary", "secondary", "tertiary"].includes(value)
    }
  },
  emits: ["close"],
  setup(__props, { emit }) {
    const props = __props;
    const slots = useSlots();
    const realVariant = computed(() => props.type !== "secondary" ? props.type : props.variant);
    const canClose = computed(() => !props.noClose);
    const hasActions = () => Boolean(slots.actions?.());
    const hasIcon = () => Boolean(props.iconPath || props.iconSvg || !!slots.icon?.());
    const onClose = () => {
      emit("close");
    };
    return { __sfc: true, props, emit, slots, realVariant, canClose, hasActions, hasIcon, onClose, mdiClose, NcActions, NcActionButton, NcIconSvgWrapper };
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "nc-chip", class: {
    [`nc-chip--${_setup.realVariant}`]: true,
    "nc-chip--no-actions": _vm.noClose && !_setup.hasActions(),
    "nc-chip--no-icon": !_setup.hasIcon()
  } }, [_setup.hasIcon() ? _c("span", { staticClass: "nc-chip__icon" }, [_vm._t("icon", function() {
    return [_vm.iconPath || _vm.iconSvg ? _c(_setup.NcIconSvgWrapper, { attrs: { "inline": "", "path": _vm.iconPath, "svg": _vm.iconPath ? void 0 : _vm.iconSvg, "size": 18 } }) : _vm._e()];
  })], 2) : _vm._e(), _c("span", { staticClass: "nc-chip__text" }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.text))];
  })], 2), _setup.canClose || _setup.hasActions() ? _c(_setup.NcActions, { staticClass: "nc-chip__actions", attrs: { "container": _vm.actionsContainer, "force-menu": !_setup.canClose, "variant": "tertiary-no-background" } }, [_setup.canClose ? _c(_setup.NcActionButton, { attrs: { "close-after-click": "" }, on: { "click": _setup.onClose }, scopedSlots: _vm._u([{ key: "icon", fn: function() {
    return [_c(_setup.NcIconSvgWrapper, { attrs: { "path": _setup.mdiClose, "size": 20 } })];
  }, proxy: true }], null, false, 2547223506) }, [_vm._v(" " + _vm._s(_vm.ariaLabelClose) + " ")]) : _vm._e(), _vm._t("actions")], 2) : _vm._e()], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "a7b8715a"
);
const NcChip = __component__.exports;
export {
  NcChip as default
};
//# sourceMappingURL=NcChip.mjs.map
